<template lang="pug">
  div
    .title.mb-3 Видео урока
    youtube-embed(
      v-if="videoUrl"
      :link="videoUrl"
      :height="height"
    )
    v-alert(v-else type="info") Видео урока еще не готово
</template>

<script>
import YoutubeEmbed from '@/components/Global/YoutubeEmbed.vue';

export default {
  name: 'ContentVideoLesson',
  components: {
    YoutubeEmbed,
  },
  props: {
    videoUrl: { type: String, default: '' },
  },
  data() {
    return {
      model: 0,
      hover: false,
    };
  },
  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '360';
        case 'sm': return '500';

        default: return '720';
      }
    },
  },
};
</script>
